import FuelCarbonData from "./FuelCarbonData"

class ConfigurationForCarbonType {
    public configurationName = ""
    public fuelInfo = new Array<FuelCarbonData>()
    public resultsForConfiguration = new Array<string>()
    public attainedcii = 0
    public modified_gt = 0
    public modified_dwt = 0
}

export default ConfigurationForCarbonType
